import { Container } from '@mui/material'
import { useParams } from 'react-router-dom'
import { CustomTextField } from '../../../components/BasicQuery.styles'
import { BasicQueriesHeader } from 'src/features/basic-queries/components/Header/Header'
import TableMui from 'src/components/TableMui'
import { useSelector, useStore } from 'src/utils/store'
import { useDispatch } from 'react-redux'
import { State } from 'src/features/types'
import { actions } from 'src/features/basic-queries/BasicQueriesState'
import { useEffect, useMemo } from 'react'
import { ProductInfoCard } from 'src/features/basic-queries/components/ProductInfoCard/ProductInfoCard'

export const ProductBatchDetails = () => {
  const params = useParams<{
    address: string,
    barcode: string
  }>()
  const store = useStore()
  const dispatch = useDispatch()
  const productInfo = useSelector((state: State) => state.basicQuery.productInfo)
  const productDetail = useSelector((state: State) => state.basicQuery.productDetail)

  useEffect(() => {
    const state = store.getState()
    dispatch(actions.getProductDetail(params))

    if (!state.basicQuery.productInfo) {
      dispatch(actions.getProductInfoByBarcode(params.barcode))
    }

    return () => {
      dispatch(actions.setProductBatchDetail())
    }
  }, [params, dispatch, store])

  const resolveBatchesTableRows = useMemo(() => productDetail?.map(({
    batch,
    stockBatchDue,
  }) => ({
    idBatch: batch.idLote,
    dueDate: batch.dataValidade,
    quantity: stockBatchDue.quantidade,
  })), [productDetail])

  return (
    <Container>
      <BasicQueriesHeader title='Estoque Detalhado'/>
      <CustomTextField
        disabled
        value={params.barcode}
        name='barcode'
        label='barcode'
        testId='barcode'
        variant='outlined'
        autoFocus
        fullWidth
        InputLabelProps={{ shrink: true }}
      />

      {
        productInfo && (
          <ProductInfoCard
            description={productInfo.productDescription}
            idModel={productInfo.idModel}
            productCode={productInfo.productCode}
          />
        )
      }

      <CustomTextField
        disabled
        value={params.address}
        name='address'
        label='address'
        testId='address'
        variant='outlined'
        autoFocus
        fullWidth
        InputLabelProps={{ shrink: true }}
      />

      {
        resolveBatchesTableRows && (
        <TableMui
          flatTable
          columns={[
            { id: 'idBatch', label: 'Lote' },
            { id: 'quantity', label: 'Estoque' },
            {
              id: 'dueDate', label: 'Validade', isDate: true, dateFormat: 'DD/MM/YYYY',
            },
          ]}
          rows={resolveBatchesTableRows}
        />
        )
      }

    </Container>
  )
}
